import { type ReactNode } from 'react';
import { useExperiment } from '@hungryroot/experiments';

export function useMealTypePageContent({
  variantToggleContent,
  defaultToggleContent,
  defaultSubcopy,
  variantSubcopy,
}: {
  variantToggleContent: (variant: number) => ReactNode;
  defaultToggleContent: ReactNode;
  defaultSubcopy: string;
  variantSubcopy: string;
}) {
  const variant = useExperiment(175);

  if (variant === undefined) {
    return;
  }

  if (variant > 0) {
    return {
      toggles: variantToggleContent(variant),
      subcopy: variantSubcopy,
      isVariant: true,
    };
  }

  return {
    toggles: defaultToggleContent,
    subcopy: defaultSubcopy,
  };
}
